export const name = 'gzDialogTitleBar';

/**
 * @ngdoc directive
 * @name gazelle.components.dialogTitleBar.directive:gzDialogTitleBar
 *
 * @param {string} title (DEPRECATED) The text to display along the title bar. This will be left-aligned.
 * @param {string} gz-title  The text to display along the title bar. This will be left-aligned.
 * @param {function} cancel (optional) A function to perform a custom cancellation process. If this is provided the developer
 *                          becomes responsible for closing the dialog. If this is not provided the dialog will be closed
 *                          by gzDialogTitleBar.
 * @param {string} gz-analytics-category (optional) The category to use for analytics reporting
 * @param {string} gz-analytics-event (optional) The event to use for analytics reporting
 * @param {string} gz-analytics-label (optional) The label to use for analytics reporting
 * @param {string} gz-analytics-action (optional) The action to use for analytics reporting
 *
 * @description Provides a consistent look for dialog title bars with built-in L10N property string conversion and a default cancel
 *              action. Passing in a property file key will enable gzDialogTitleBar to conduct the L10N conversion. By
 *              default gzDialogTitleBar will take care of closing the dialog when the close icon is linked, however, you
 *              can specifiy a custom function to execute as well. If this route is take then the developer bears responsibility
 *              for closing the dialog.
 *
 * @usage
 * ````html
 *
 * // With custom cancellation
 * <gz-dialog-title-bar title="account.account.somePropertyKey" cancel="vm.doCancel"></gz-dialog-title-bar>
 *
 * // With default cancellation
 * <gz-dialog-title-bar title="account.account.somePropertyKey"></gz-dialog-title-bar>
 *
 * ````
 */

export default function gzDialogTitleBar() {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let directive = {
    restrict: 'E',
    scope: {
      title: '@',
      gzTitle: '@',
      cancel: '=?'
    },
    template: require('./dialog-title-bar.jade'),
    controllerAs: 'vm',
    bindToController: true,
    link: gzDialogTitleBarLink,
    controller: gzDialogTitleBarController
  };

  return directive;

  /////////////////////

  function gzDialogTitleBarLink(scope, elem, attrs) {
    // Add category
    if (attrs.hasOwnProperty('gzAnalyticsCategory')) {
      scope.vm.setCategory(attrs.gzAnalyticsCategory);
    }

    // Add event
    if (attrs.hasOwnProperty('gzAnalyticsEvent')) {
      scope.vm.setEvent(attrs.gzAnalyticsEvent);
    }

    // Add label
    if (attrs.hasOwnProperty('gzAnalyticsLabel')) {
      scope.vm.setLabel(attrs.gzAnalyticsLabel);
    }

    // Add value
    if (attrs.hasOwnProperty('gzAnalyticsValue')) {
      scope.vm.setValue(attrs.gzAnalyticsValue);
    }
  }

  /** @ngInject */
  function gzDialogTitleBarController($mdDialog, $gzAnalytics) {

    let vm = this;
    let event = 'GZ EVENT';
    let eventObj = {
      category: 'GZ EVENT CATEGORY'
    };

    vm.defaultCancel = defaultCancel;
    vm.setCategory = setCategory;
    vm.setEvent = setEvent;
    vm.setLabel = setLabel;
    vm.setValue = setValue;

    vm.$onInit = onInit;

    ////////////////////

    function onInit() {

      // If a title is not provided assign the warning title
      if (vm.gzTitle) {
        vm.dialogTitle = vm.gzTitle;
      }
      else if (vm.title) {
        vm.dialogTitle = vm.title;
      }
      else {
        vm.dialogTitle = 'uxf.uxf.No_Title';
      }

      // If a custom cancel function is not provided assign the default cancel function
      if (vm.cancel === undefined) {
        vm.cancel = defaultCancel;
      }
    }

    function setEvent(anEvent) {
      event = anEvent;
    }

    function setCategory(category) {
      eventObj.category = category;
    }

    function setLabel(label) {
      eventObj.label = label;
    }

    function setValue(value) {
      eventObj.value = value;
    }

    function defaultCancel() {
      $mdDialog.cancel();

      // An event has been reported
      if (event !== 'GZ EVENT') {
        $gzAnalytics.eventCancel(event, eventObj);
      }
    }
  }
}
